var React = require('react');

function MonitorIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#323E4E","d":"M27.328 0H1.673C.749.001 0 .763 0 1.704v16.06c.001.941.75 1.704 1.673 1.705h10.33v2.397H9.506c-1.157 0-2.095.955-2.095 2.134H21.59c0-1.179-.938-2.134-2.094-2.134h-2.498V19.47h10.33c.924-.001 1.672-.764 1.673-1.705V1.704C28.999.764 28.25.001 27.328 0zm.06 17.764c0 .035-.027.063-.06.063H1.673c-.017 0-.032-.006-.044-.018-.011-.012-.018-.028-.018-.045V1.704c0-.035.028-.063.062-.063h25.655c.033 0 .06.028.06.063v16.06z"}));
}

MonitorIcon.defaultProps = {"width":"29","height":"24","viewBox":"0 0 29 24"};

module.exports = MonitorIcon;

MonitorIcon.default = MonitorIcon;
